export const getTypeString = (integrationName?: string) => {
  const name = integrationName?.toLocaleLowerCase().replace(' ', '_');

  if (name === 'hubspot') {
    return 'hubspot_scrape';
  }

  return name;
};
